import moment from 'moment';
import { fillDocsArray } from 'helpers/Uploads';
import { formatBands, defaultBands } from 'helpers/Bands';
import testTypes from 'dictionaries/TestTypes';

export function getRequestBackbone() {
  return {
    modelName: '',
    deviceType: 0,
    pocFirstName: '',
    pocLastName: '',
    pocEmail: '',
    pocPhone: '',
    cdmaLab: 0,
    // cdmaLabPoc: 0,
    certificationOption: false,
    agreementAccepted: false,
    vendorAgreementAccepted: false,
    usersManual: {
      file: null,
      status: 1
    },
    supportDocs: fillDocsArray(),
    bands: formatBands(defaultBands),
    fccId: '',
    submissionDate: '',
    tests: [],
    testInfo: {
      testType: testTypes.winnfTs0122,
      testResult: 0,
      planVersion: '',
      fccId: '',
      hardwareVersion: '',
      softwareVersion: '',
      testEndDate: moment(),
      testStartDate: moment(),
      reportedDate: ''
    },
    hwVersion: '',
    swVersion: '',
    descriptionOfChange: ''
  };
}



// WEBPACK FOOTER //
// ./src/helpers/RequestBackbone.js